/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dangerzone1Inputs */

const en_dangerzone1 = /** @type {(inputs: Dangerzone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danger Zone`)
};

const de_dangerzone1 = /** @type {(inputs: Dangerzone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gefahrenzone`)
};

/**
* | output |
* | --- |
* | "Danger Zone" |
*
* @param {Dangerzone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dangerzone1 = /** @type {((inputs?: Dangerzone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dangerzone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dangerzone1(inputs)
	return de_dangerzone1(inputs)
});
export { dangerzone1 as "dangerZone" }